module.exports = __webpack_public_path__ + "img/es.95e64c00.svg";